module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"attention":"¡Atención!","maintainOrder":"Mantener orden","moveOrder":"Mover orden"},"en":{"attention":"Attention!","moveOrder":"Move order","maintainOrder":"Maintain order"}}')
  delete Component.options._Ctor
}
